"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePaginationStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makePaginationStyles = function makePaginationStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiPagination: {
      styleOverrides: {
        root: {
          '& + [class*="MuiTypography-root"]': {
            lineHeight: primitives.lineHeights["compact"],
            paddingTop: primitives.spacings["1"]
          }
        },
        ul: {
          justifyContent: "center",
          "& li": {
            margin: "0px 2px",
            "&:focus-visible": {
              outline: "none"
            }
          }
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({
          border: "".concat(primitives.borderWidths["medium"], " solid transparent"),
          padding: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["3"])
        }, tokens.typography["short-copy-small"]), {}, {
          lineHeight: primitives.lineHeights["default"],
          minWidth: primitives.spacings["7"],
          maxWidth: primitives.spacings["7"],
          height: primitives.spacings["7"],
          margin: 0,
          borderRadius: primitives.borderRadii["small"]
        }, tokens.transitions["state-blur"]), {}, {
          color: tokens.colors["ink-on-background"].rgb,
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["activated-fill-subtle"].rgb
          }, tokens.transitions["state-activate"]),
          "&:active": _objectSpread({
            backgroundColor: tokens.colors["activated-hover-fill-subtle"].rgb
          }, tokens.transitions["state-activate"]),
          "&:focus-visible": _objectSpread({
            backgroundColor: tokens.colors["ink-on-fill-primary"].rgb,
            boxShadow: tokens.effects["focus-ring-reverse"].boxShadow
          }, tokens.transitions["state-activate"]),
          "&.Mui-selected": _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["ink-on-fill-primary"].rgb,
            border: "".concat(primitives.borderWidths["medium"], " solid ").concat(tokens.colors["ink-on-background"].rgb)
          }, tokens.transitions["state-activate"]), {}, {
            "&:hover": {
              backgroundColor: tokens.colors["ink-on-fill-primary"].rgb
            },
            "&:focus-visible": {
              backgroundColor: tokens.colors["ink-on-fill-primary"].rgb
            }
          })
        }),
        previousNext: {
          borderRadius: "50%",
          minWidth: primitives.spacings["6"],
          maxWidth: primitives.spacings["6"],
          height: primitives.spacings["6"],
          padding: "unset"
        },
        ellipsis: {
          cursor: "default",
          "&:hover, &:active, &:focus-visible": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
};

exports.makePaginationStyles = makePaginationStyles;